import React from "react";
import {
  PortalAuthActions,
  PortalAuthBrandAccent,
  PortalAuthBrandLogo,
  PortalAuthBrandPanel,
  PortalAuthContentPanel,
  PortalAuthContentShell,
  PortalAuthLayout,
  PortalAuthMessage,
  PortalAuthSpinnerWrapper,
  PortalAuthTitle,
} from "./PortalAuthShell.styles";

interface PortalAuthShellProps {
  branding?: React.ReactNode;
  children: React.ReactNode;
  description?: string;
  isError?: boolean;
  title?: string;
}

interface PortalAuthBrandingProps {
  accentSrc: string;
  logoAlt: string;
  logoSrc: string;
  logoWidth?: string;
}

export const PortalAuthBranding = ({
  accentSrc,
  logoAlt,
  logoSrc,
  logoWidth = "321px",
}: PortalAuthBrandingProps): React.ReactElement => (
  <>
    <PortalAuthBrandAccent src={accentSrc} alt="" aria-hidden="true" />
    <PortalAuthBrandLogo src={logoSrc} alt={logoAlt} $width={logoWidth} />
  </>
);

export const PortalAuthShell = ({
  branding,
  children,
  description,
  isError = false,
  title,
}: PortalAuthShellProps): React.ReactElement => (
  <PortalAuthLayout>
    {branding ? <PortalAuthBrandPanel>{branding}</PortalAuthBrandPanel> : null}
    <PortalAuthContentPanel>
      <PortalAuthContentShell>
        {title ? (
          <PortalAuthTitle $isError={isError}>{title}</PortalAuthTitle>
        ) : null}
        {description ? (
          <PortalAuthMessage>{description}</PortalAuthMessage>
        ) : null}
        {children}
      </PortalAuthContentShell>
    </PortalAuthContentPanel>
  </PortalAuthLayout>
);

export { PortalAuthActions, PortalAuthSpinnerWrapper };
